const INITIAL_STATE = {
  items: null,
  refs: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "ITEMS_FETCH":
      return {
        ...state,
        items: action.payload,
      };
    case "REFS_FETCH":
      return {
        ...state,
        refs: action.payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/fetchReducer.js